import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Breadcrumb from "@/components/feature/Breadcrumb";
import TrustBannerSection from "@/components/feature/TrustBannerSection";

export default function Cookies() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="Política de Cookies | Persianas Málaga"
        description="Política de cookies de Persianas Málaga. Información sobre las cookies utilizadas en este sitio web de reparación de persianas y mosquiteras en Málaga capital."
        noindex
      />
      <Navbar />
      <Breadcrumb items={[
        { label: "Inicio", path: "/" },
        { label: "Cookies" },
      ]} />
      <main className="pb-20 md:pb-0">
        <section className="py-14 md:py-20">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-8 font-heading">Política de Cookies</h1>
            <div className="prose prose-sm max-w-none text-foreground-700 space-y-6">
              <p>Este sitio web utiliza cookies propias y de terceros para mejorar la experiencia de navegación y analizar el tráfico de forma anónima.</p>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">¿Qué son las cookies?</h2>
              <p>Las cookies son pequeños archivos de texto que los sitios web instalan en el dispositivo del usuario para almacenar información sobre su visita. No contienen virus ni software malicioso.</p>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Tipos de cookies utilizadas</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Cookies técnicas:</strong> Necesarias para el correcto funcionamiento del sitio web.</li>
                <li><strong>Cookies analíticas:</strong> Permiten medir y analizar la actividad en el sitio de forma anónima (Google Analytics).</li>
              </ul>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Desactivación de cookies</h2>
              <p>El usuario puede configurar su navegador para rechazar o eliminar las cookies. Consulte la ayuda de su navegador para más información.</p>
            </div>
          </div>
        </section>
      </main>
      <TrustBannerSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}